import { Grid, Paper, Typography } from "@mui/material";
import EntityInfoFields from "./EntityInfoFields";
import AddressFields from "./AddressFields";
import ImageWrapper from "./ImageWrapper";

function DetailsCard() {
  return (
    <Paper elevation={3}>
      <Grid
        container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignContent: "flex-start",
          padding: 4,
        }}
      >
        <Grid data-testid="details-card-header" size={12}>
          <Typography sx={{ paddingBottom: 2 }} align="left" variant="h5">
            Details
          </Typography>
        </Grid>
        <Grid
          data-testid="details-card-entity-info"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignContent: "flex-start",
            padding: 2,
          }}
        >
          <EntityInfoFields />
        </Grid>
        <Grid
          container
          data-testid="details-card-outer-container"
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 2,
          }}
        >
          <Grid
            data-testid="details-card-inner-address"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignContent: "flex-start",
            }}
          >
            <AddressFields />
          </Grid>
          <Grid
            data-testid="details-card-inner-profile-image"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <ImageWrapper />
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default DetailsCard;
